module.exports = __webpack_public_path__ + "img/social-media-display-kia.43d161df.png";